// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__NexaBlack_e9e825', '__NexaBlack_Fallback_e9e825'"},"className":"__className_e9e825","variable":"__variable_e9e825"};